import { FavoritesItemType, LodgingCollectionEnum } from "redmond";
import { StayType } from "redmond/hotels-module/interfaces";

const stayTypeMap: Partial<Record<StayType, "hotel" | "vr">> = {
  [StayType.Hotels]: "hotel",
  [StayType.Homes]: "vr",
};

const collectionTypePrefixMap: Record<LodgingCollectionEnum, string> = {
  [LodgingCollectionEnum.Premier]: "premier_",
  [LodgingCollectionEnum.Lifestyle]: "lifestyle_",
  [LodgingCollectionEnum.NoCollection]: "",
};

export const getFavoritesItemType = (
  stayType: StayType,
  lodgingCollection: LodgingCollectionEnum
): FavoritesItemType => {
  const baseItemType = stayType ? stayTypeMap[stayType] : "";
  const prefix = lodgingCollection
    ? collectionTypePrefixMap[lodgingCollection]
    : "";
  const itemType = `${prefix}${baseItemType}` as FavoritesItemType;
  return itemType;
};
